<agr-dialog
  [ngClass]="
    groupedTreatments().length && !isOnMobile()
      ? 'spray-application-dialog-with-gbm-treatments'
      : 'spray-application-dialog'
  "
  [data]="data"
  [contentSpacing]="true"
  (cancel)="cancel()"
>
  <ng-container details>
    <div class="selected-crop-fields">
      <mat-chip-listbox>
        @for (cropField of selectedCropFields(); track cropField.cropFieldId) {
          <mat-chip-option
            [selectable]="false"
            [removable]="selectedCropFields().length > 1 && !isReadonlyMode()"
            (removed)="removeCropField(cropField.cropFieldId)"
          >
            <b>{{ cropField.cropFieldName }}</b> {{ cropField.areaInHectares }} {{ 'hectares' | translate }}
            @if (selectedCropFields().length > 1 && !isReadonlyMode()) {
              <mat-icon class="selected-crop-fields__remove" matChipRemove data-test="crop-remove">cancel</mat-icon>
            }
          </mat-chip-option>
        }
      </mat-chip-listbox>
    </div>
  </ng-container>

  <div [ngClass]="{ 'two-column-layout': groupedTreatments().length && !isOnMobile() }">
    @if (groupedTreatments().length && !isOnMobile()) {
      <div class="left-column">
        <div class="notification notification-warning">
          <mat-icon>warning</mat-icon>
          <div class="notification__content">
            <strong class="text--warning" [innerHTML]="'gbmWarningTitle' | translate"></strong>
            <p class="notification__description" [innerHTML]="'gbmWarningDescription2' | translate"></p>
          </div>
        </div>
        <div class="advices-tables">
          <div class="adviced-treatments-table">
            <p class="table-title spacing--margin-vertical">
              <strong>{{ 'blight.sprays.advicedTreatmentsTableTitle' | translate }}</strong>
            </p>
            @for (group of groupedTreatments(); track group.cropFieldId) {
              <span class="spacing--margin-vertical">
                <span class="text--bold">{{ 'cropField' | translate }}</span> {{ group.cropFieldName }}
              </span>
              <mat-table [dataSource]="group.treatments" class="table-wrapper spacing--margin-bottom">
                <ng-container matColumnDef="name">
                  <mat-header-cell *matHeaderCellDef class="flex__child--3">
                    <div class="text--right spacing--margin-right">
                      <span>{{ 'treatment' | translate }}</span>
                    </div>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let treatment" class="flex__child--3">
                    <span>{{ treatment.name }}</span>
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="objective">
                  <mat-header-cell *matHeaderCellDef class="flex__child--1">
                    <div class="text--right spacing--margin-right">
                      <span>{{ 'objective' | translate }}</span>
                    </div>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let treatment" class="flex__child--1">
                    <span>{{ treatment.objective | translate }}</span>
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="frequency">
                  <mat-header-cell *matHeaderCellDef class="flex__child--2">
                    <div class="text--right spacing--margin-right">
                      <span>{{ 'frequency' | translate }}</span>
                    </div>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let treatment" class="flex__child--2">
                    <span>{{ treatment.frequency }}</span>
                  </mat-cell>
                </ng-container>
                <mat-header-row
                  *matHeaderRowDef="['name', 'objective', 'frequency']"
                  [class.mat-header-row-sticky]="true"
                >
                </mat-header-row>
                <mat-row *matRowDef="let _row; columns: ['name', 'objective', 'frequency']"></mat-row>
              </mat-table>
            }
          </div>
        </div>
      </div>
    }

    <div class="dialog-content" [ngClass]="{ 'right-column': groupedTreatments().length && !isOnMobile() }">
      @if (!isFmsReadonlyMode()) {
        <div class="form-grid">
          <mat-form-field
            subscriptSizing="dynamic"
            data-test="spray-date"
            [matTooltip]="'UI.CurrentYearOnlyMutationMessage' | translate"
            [matTooltipDisabled]="!data.readOnly"
          >
            <mat-label>{{ 'blight.date' | translate }}</mat-label>
            <input
              matInput
              [formField]="sprayApplicationForm.date"
              [matDatepicker]="sprayDatePicker"
              [placeholder]="'blight.date' | translate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="sprayDatePicker"
              [disabled]="isReadonlyMode()"
            ></mat-datepicker-toggle>
            <mat-datepicker #sprayDatePicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field
            subscriptSizing="dynamic"
            data-test="spray-time"
            [matTooltip]="'UI.CurrentYearOnlyMutationMessage' | translate"
            [matTooltipDisabled]="!data.readOnly"
          >
            <mat-label>{{ 'blight.time' | translate }}</mat-label>
            <input
              matInput
              type="text"
              inputmode="numeric"
              placeholder="08:30"
              [formField]="sprayApplicationForm.time"
              (input)="updateTimeInput($event)"
              (blur)="normalizeTimeInput()"
            />
            @if (showTimeFormatWarning()) {
              <mat-error>{{ 'sprayApplications.invalidTimeFormat' | translate }}</mat-error>
            }
          </mat-form-field>

          @if (showSprayTypeSelection()) {
            <div class="form-grid__full-width spray-type-selection" data-test="spray-type">
              <span class="spray-type-selection__label">{{ 'sprayApplications.sprayType' | translate }}</span>
              <span
                class="spray-control-tooltip"
                [matTooltip]="'UI.CurrentYearOnlyMutationMessage' | translate"
                [matTooltipDisabled]="!data.readOnly"
              >
                <mat-radio-group class="spray-type-selection__options" [formField]="sprayApplicationForm.sprayType">
                  @for (sprayType of availableSprayTypes(); track sprayType.value) {
                    <mat-radio-button [value]="sprayType.value" color="primary">
                      {{ sprayType.label | translate }}
                    </mat-radio-button>
                  }
                </mat-radio-group>
              </span>
            </div>
          }

          <mat-form-field
            class="form-grid__full-width"
            subscriptSizing="dynamic"
            data-test="spray-select"
            [matTooltip]="'UI.CurrentYearOnlyMutationMessage' | translate"
            [matTooltipDisabled]="!data.readOnly"
          >
            <mat-label>{{ 'sprayApplications.predefinedSpray' | translate }}</mat-label>
            <mat-select [formField]="sprayApplicationForm.sprayId">
              @if (selectedSprayDisplayName(); as sprayDisplayName) {
                <mat-select-trigger>{{ sprayDisplayName }}</mat-select-trigger>
              }

              @if (sprayApplicationForm.sprayId().value(); as selectedSprayId) {
                @if (!selectedSpray() && selectedSprayDisplayName(); as sprayDisplayName) {
                  <mat-option [value]="selectedSprayId">{{ sprayDisplayName }}</mat-option>
                }
              }

              @for (sprayCocktail of sprayCocktails(); track sprayCocktail.id) {
                <mat-option [value]="sprayCocktail.id">
                  {{ sprayCocktail.name }}
                  @if (sprayCocktail.preferred) {
                    <span class="preferred-tag">{{ 'sprayApplications.preferred' | translate }}</span>
                  }
                </mat-option>
              }
            </mat-select>
            @if (!isLoadingSprays() && !sprayCocktails().length) {
              <mat-hint>{{ 'sprayApplications.noSpraysAvailable' | translate }}</mat-hint>
            }
          </mat-form-field>
        </div>
      }

      @if (isFmsReadonlyMode()) {
        <div class="notification notification-info">
          <mat-icon>info</mat-icon>
          {{ fmsReadonlyMessageKey | translate }}
        </div>
      }

      @if (!isFmsReadonlyMode()) {
        <span
          class="spray-control-tooltip"
          [matTooltip]="'UI.CurrentYearOnlyMutationMessage' | translate"
          [matTooltipDisabled]="!data.readOnly"
        >
          <button
            mat-flat-button
            color="accent"
            type="button"
            data-test="add-spray-application"
            (click)="submitSprayApplication()"
            [disabled]="isAddDisabled()"
          >
            <span class="add-spray-button__icon" aria-hidden="true">
              @if (isSubmitting()) {
                <mat-icon class="add-spray-button__spinner">autorenew</mat-icon>
              } @else {
                <mat-icon>add</mat-icon>
              }
            </span>
            <span>{{ 'add' | translate }}</span>
          </button>
        </span>
      }

      <div class="history-divider" aria-hidden="true"></div>
      <h3 class="history-header">{{ 'sprayApplications.historyTitle' | translate }}</h3>

      @if (isLoadingHistory()) {
        <div class="history-loading">
          <mat-spinner diameter="28"></mat-spinner>
        </div>
      } @else if (isFmsReadonlyMode()) {
        <div class="history-groups">
          @for (cropField of selectedCropFields(); track cropField.cropFieldId) {
            <section class="history-group">
              <div class="group-title">
                <b>{{ cropField.cropFieldName }}</b>
              </div>
              @if (groupedHistoryByCropFieldId().get(cropField.cropFieldId); as group) {
                <ng-container
                  [ngTemplateOutlet]="sprayHistoryTable"
                  [ngTemplateOutletContext]="{ group: group }"
                ></ng-container>
              } @else {
                <div class="notification" [ngClass]="mappedCropFieldNoSpraysNotificationClass">
                  <mat-icon>{{ mappedCropFieldNoSpraysIcon }}</mat-icon>
                  {{ 'fmsSync.cropFieldMappedNoSprays' | translate }}
                </div>
              }
            </section>
          }
        </div>
      } @else if (!groupedHistory().length) {
        <div class="notification notification-info">
          <mat-icon>info</mat-icon>
          {{ 'sprayApplications.noHistory' | translate }}
        </div>
      } @else {
        <div class="history-groups">
          @for (group of groupedHistory(); track group.cropFieldId) {
            <section class="history-group">
              <div class="group-title">
                <b>{{ group.cropFieldName }}</b>
              </div>

              <ng-container
                [ngTemplateOutlet]="sprayHistoryTable"
                [ngTemplateOutletContext]="{ group: group }"
              ></ng-container>
            </section>
          }
        </div>
      }
    </div>
  </div>

  <ng-template #sprayHistoryTable let-group="group">
    <mat-table [dataSource]="group.sprays" class="table-wrapper" data-test="spray-history-table">
      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef>{{ 'blight.date' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let spray">
          {{ spray.applicationDate | date: 'shortDate' : 'UTC' : locale }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="time">
        <mat-header-cell *matHeaderCellDef>{{ 'blight.time' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let spray">
          {{ spray.applicationDate | date: 'HH:mm' : 'UTC' : locale }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="sprayNumber">
        <mat-header-cell *matHeaderCellDef>{{ 'blight.sprayNumber' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let spray">{{ spray.sprayNumber }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="spray">
        <mat-header-cell *matHeaderCellDef>{{ sprayHistoryHeaderKey() | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let spray">{{ spray.name }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let spray">
          <button
            mat-icon-button
            type="button"
            data-test="delete-spray-application"
            (click)="deleteSprayApplication(group.cropFieldId, spray.id)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns()"></mat-header-row>
      <mat-row *matRowDef="let _row; columns: displayedColumns()"></mat-row>
    </mat-table>
  </ng-template>
</agr-dialog>
